import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.weak-map.get-or-insert.js";
import "core-js/modules/es.weak-map.get-or-insert-computed.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import JSEncrypt from "jsencrypt";
export function isObject(obj) {
  return Object.prototype.toString.call(obj) == "[object Object]";
}
export function isPrimitive(value) {
  return typeof value === "string" || typeof value === "number" || typeof value === "symbol" || typeof value === "boolean" || typeof value === "function";
}
export function isArray(obj) {
  return Object.prototype.toString.call(obj) == "[object Array]";
}
export function isString(obj) {
  return Object.prototype.toString.call(obj) == "[object String]";
}
export function isBlob(obj) {
  return Object.prototype.toString.call(obj) == "[object Blob]";
}
export function isNumber(obj) {
  return Object.prototype.toString.call(obj) == "[object Number]";
}
export function isDate(obj) {
  return Object.prototype.toString.call(obj) == "[object Date]";
}
export function isFunction(obj) {
  return Object.prototype.toString.call(obj) == "[object Function]";
}
export function isMobile(mobile) {
  mobile = trim(mobile);
  const exp = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  if (exp.test(mobile)) {
    return true;
  } else {
    return false;
  }
}
export function isPhone() {
  const isPhone = /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(window.navigator.userAgent);
  if (isPhone) {
    return true;
  } else {
    return false;
  }
}
export function walkObj(obj, handler, context) {
  if (isEmpty(obj)) {
    // console.error("遍历的obj对象为空");
    return;
  }
  const keys = Object.keys(obj);
  const len = keys.length;
  let key = null,
    value = null;
  for (let i = 0; i < len; i++) {
    key = keys[i];
    value = obj[key];
    if (!isEmpty(handler)) {
      const stop = handler.call(context, value, key, obj);
      if (stop) {
        return;
      }
    }
  }
}
/**
 *
 * 判断是否为空
 * @export
 * @param {*} obj
 * @return {*}  {boolean}
 */
export function isEmpty(obj) {
  return obj === undefined || obj === null || obj === "" || obj === " ";
}
export function isEmptyObject(obj) {
  if (isEmpty(obj)) {
    return true;
  }
  if (isArray(obj) && obj.length === 0) {
    return true;
  }
  if (isObject(obj) && Object.keys(obj).length === 0) {
    return true;
  }
  return false;
}
/**
 *
 * 去除字符串前后空格
 * @export
 * @param {string} str
 * @return {*}  {string}
 */
export function trim(str) {
  if (str) {
    return str.replace(/(^[ \t\n\r]+)|([ \t\n\r]+$)/g, "");
  }
  return str;
}
export function walkArray(array, handler, context) {
  if (isEmpty(array)) {
    return;
  }
  const len = array.length;
  let value;
  for (let i = 0; i < len; i++) {
    value = array[i];
    if (!isEmpty(handler)) {
      const stop = handler.call(context, value, i, array);
      if (stop) {
        return;
      }
    }
  }
}
/**
 * Generating a random int in range (0, max - 1)
 * @param max {number}
 */
export function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}
/**
 *
 * 获取多少位小数会自动四舍五入
 * @export
 * @param {number} num
 * @param {number} fixNum
 * @return {*}
 */
export function getRoundNum(num, fixNum) {
  return Math.floor(Math.round(Math.pow(10, fixNum) * num)) / Math.pow(10, fixNum);
}
/**
 *
 * 将含横杠字符串转成驼峰式字符串如：article-author-name 转成 驼峰式 articleAuthorName
 * @export
 * @param {string} str
 * @return {*}
 */
export function camelize(str) {
  return str.replace(/-(\w)/g, (_, c) => c ? c.toUpperCase() : "");
}
// export function requireDir(
//   container: Record<string | number, any>,
//   path: string,
//   Regex: RegExp
// ): Record<string | number, any> {
//   const modulesFiles = require.context(path, true, Regex);
//   container = modulesFiles.keys().reduce((modules, modulePath) => {
//     const moduleName: string = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
//     const value = modulesFiles(modulePath);
//     modules[moduleName] = value.default;
//     return modules;
//   }, container);
//   return container;
// }
/**
 *
 * 将 source上所有属性复制一份到target上，当有相同属性时会不会覆盖取决于override是否为true,默认为true
 * @export
 * @param {*} target
 * @param {*} source
 * @param {boolean} [isInter=false]
 * @param {boolean} [override=true]
 * @return {*}
 */
export function extend(target, source, isInter = false, override = true) {
  if (!override) {
    if (isEmpty(source)) {
      return target;
    }
  }
  if (isPrimitive(source)) {
    if (override || isEmpty(target)) {
      target = source;
    }
  } else if (isObject(source)) {
    if (isInter) {
      if (!isObject(target)) {
        target = {};
      }
    }
    for (const p in source) {
      if (Object.prototype.hasOwnProperty.call(source, p)) {
        target[p] = extend(target[p], source[p], true, override);
      }
    }
  } else if (isArray(source)) {
    if (isInter) {
      if (!isArray(target)) {
        target = [];
      }
    }
    const len = source.length;
    for (let i = 0; i < len; i++) {
      target[i] = extend(target[i], source[i], true, override);
    }
  }
  return target;
}
/**
 * 深度递归搜索
 * @param {Array} arr 你要搜索的数组
 * @param {Function} condition 回调函数，必须返回谓词，判断是否找到了。会传入(item, index, level)三个参数
 * @param {String} children 子数组的key
 */
export const deepFind = (arr, condition, children) => {
  // 即将返回的数组
  // console.log("撒旦法撒大2222", arr, condition, children);
  const main = [];
  // 用try方案方便直接中止所有递归的程序
  try {
    // 开始轮询
    (function poll(arr, level) {
      // 如果传入非数组
      if (!Array.isArray(arr)) return;
      // 遍历数组
      for (let i = 0; i < arr.length; i++) {
        // 获取当前项
        const item = arr[i];
        // 先占位预设值
        main[level] = item;
        // 检验是否已经找到了
        const isFind = condition && condition(item, i, level) || false;
        // 如果已经找到了
        if (isFind) {
          // 直接抛出错误中断所有轮询
          throw Error;
          // 如果存在children，那么深入递归
        } else if (children && item[children] && item[children].length) {
          poll(item[children], level + 1);
          // 如果是最后一个且没有找到值，那么通过修改数组长度来删除当前项
        } else if (i === arr.length - 1) {
          // 删除占位预设值
          main.length = main.length - 1;
        }
      }
    })(arr, 0);
    // 使用try/catch是为了中止所有轮询中的任务
  } catch (err) {
    console.log(err);
  }
  // 返回最终数组
  return main;
};
export function ArrayToObject(object, array, config = {
  deep: true,
  key: "name",
  childKey: "children"
}) {
  walkArray(array, function (item) {
    object[item[config.key]] = item;
    if (config.deep && item[config.childKey]) {
      ArrayToObject(object, item[config.childKey], config);
    }
    if (config.handler) {
      object[item[config.key]] = config.handler(object[item[config.key]]);
    }
  });
  return object;
}
export function bubbleSort(arr, config = {
  key: "",
  asc: true
}) {
  const len = arr.length;
  for (let i = 0; i < len - 1; i++) {
    for (let j = 0; j < len - 1 - i; j++) {
      const valuej = config.key ? arr[j][config.key] : arr[j];
      const valuej1 = config.key ? arr[j + 1][config.key] : arr[j + 1];
      if (config.asc) {
        if (valuej > valuej1) {
          // 相邻元素两两对比
          const temp = arr[j + 1]; // 元素交换
          arr[j + 1] = arr[j];
          arr[j] = temp;
        }
      } else {
        if (valuej < valuej1) {
          // 相邻元素两两对比
          const temp = arr[j + 1]; // 元素交换
          arr[j + 1] = arr[j];
          arr[j] = temp;
        }
      }
    }
  }
  return arr;
}
//权限对应排序
export function sortTree(arr = [], newArr = []) {
  arr = arr.sort((a, b) => {
    return Number(a.sortNo) - Number(b.sortNo);
  });
  arr.forEach(item => {
    // if (item.permissionFlag.length != 0 && item.permissionFlag.indexOf("[") > -1) {
    //   item.permissionFlag = JSON.parse(item.permissionFlag);
    //   const childrenArr: any = [];
    //   if (item.children && item.children.length != 0) {
    //     sortTree(item.children, childrenArr);
    //   }
    //   item.children = childrenArr;
    //   newArr.push(item);
    // }
    const childrenArr = [];
    if (item.children && item.children.length != 0) {
      sortTree(item.children, childrenArr);
    }
    item.children = childrenArr;
    newArr.push(item);
  });
  // return newArr;
}
//权限对应权限
export function shakeTree(list = []) {
  let newlist = [];
  newlist = list.filter(item => {
    return item.type == "menu";
  });
  // console.log("menu", newlist);
  newlist.forEach(item => {
    if (item.children && item.children.length > 0) {
      item.buttons = item.children.filter(item => {
        return item.type == "button";
      });
      item.children = shakeTree(item.children);
    }
  });
  // console.log("end", newlist);
  return newlist;
}
// 节流
export function throttle(fn, t = 500) {
  let flag = true;
  const interval = t;
  return function (...args) {
    if (flag) {
      fn.apply(this, args);
      flag = false;
      setTimeout(() => {
        flag = true;
      }, interval);
    }
  };
}
// 防抖
export function debounce(fn, delay = 500) {
  // 维护一个 timer
  let timer = null;
  return function (...args) {
    // 通过 ‘this’ 和 ‘arguments’ 获取函数的作用域和变量
    const context = this;
    fn.apply(context, args);
    timer = setTimeout(function () {
      clearTimeout(timer);
    }, delay);
  };
}
/**
 *
 * 生成防抖函数
 * @export
 * @param {()=>void} fn
 * @param {number} [delay=500]
 * @return {*}
 */
export function debounceMethod(fn, delay = 500) {
  let timer = null;
  return function (...args) {
    const context = this;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
}
// 获取全部
export function allChild(list, rt) {
  for (const item of list) {
    rt.push(item.permissionFlag);
    if (item.children && item.children.length > 0) {
      allChild(item.children, rt);
    }
    if (item.buttons && item.buttons.length > 0) {
      allChild(item.buttons, rt);
    }
  }
}
// 递归删除指定的节点
export function deleteNode(list, condition) {
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    if (condition && condition(item)) {
      list.splice(i, 1);
      return true;
    } else if (item.children && item.children.length > 0) {
      const res = deleteNode(item.children, condition);
      if (res) break;
    }
  }
}
// RSA加密
export function encryptDeal(msg) {
  const publicKey = "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKbpotLkdWJlxvWuydKwQkryMb3m2mZrj8tizRUbwBW9Bnyu0syIXz+IkxP6Z76b4cEO2NyEq5yPcJdaBKynSVcCAwEAAQ==";
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKey);
  return encrypt.encrypt(msg);
}
export function deepClone(originObj, map = new WeakMap()) {
  if (originObj instanceof Set) return new Set([...originObj]);
  if (originObj instanceof Map) return new Map([...originObj]);
  if (originObj instanceof RegExp) return new RegExp(originObj);
  if (originObj instanceof Date) return new Date(originObj);
  if (typeof originObj === "symbol") return originObj;
  if (typeof originObj === "function") return originObj;
  if (!isObject(originObj)) return originObj;
  if (map.has(originObj)) return map.get(originObj);
  const newObj = Array.isArray(originObj) ? [] : {};
  map.set(originObj, newObj);
  for (const key in originObj) {
    newObj[key] = deepClone(originObj[key], map);
  }
  // 对symbol的key做特殊处理
  const symbolKeys = Object.getOwnPropertySymbols(originObj);
  for (const sKeys of symbolKeys) {
    const newSkey = new Symbol(sKeys.description);
    newObj[newSkey] = deepClone(originObj[sKeys], map);
  }
  return newObj;
}
export function downloadImage(config) {
  const a = document.createElement("a"); // 创建一个a标签
  a.href = config.src; // a标签的src属性赋值
  if (config.target) {
    a.target = config.target;
  }
  a.download = config.fileName; // a标签的download属性赋值
  document.body.appendChild(a); // 添加a标签到body下
  a.click(); // 触发a标签点击事件
  document.body.removeChild(a);
}
export function downloadFileAndChangeName(url, name) {
  const xml = new XMLHttpRequest();
  xml.open("GET", url, true);
  xml.responseType = "blob";
  xml.onload = function () {
    const r_url = window.URL.createObjectURL(xml.response);
    const a = document.createElement("a");
    a.href = r_url;
    a.download = name;
    // 使用a标签批量下载文件时最好使用_blank，否则只会下载最后一个文件
    a.setAttribute("target", "_blank");
    a.click();
    a.remove();
  };
  xml.send();
}
//生成 7位随机数 且
export function randomNumber(digit) {
  let code = "" + (parseInt(Math.random() * 1000000 + "") + 1000000);
  code = code.substring(1, digit);
  return code;
}